import { useKeycloak } from "@react-keycloak/web";
import { create } from "zustand";
import { getUsers } from "../api/users";
import { addUserToProject } from "../api/projects";

// Cache with 15-minute TTL to prevent duplicate requests
const usersCache = new Map<string, { data: ProjectUsersInterface; timestamp: number }>();
const USERS_CACHE_TTL = 15 * 60 * 1000;

export const useUsersStore = create<UserStore>((set) => {
  return {
    users: [],
    pagination: {
      page: 0,
      size: 0,
      total: 0
    },
    setUsersPage: (projectUsersPageData: ProjectUsersInterface) => {
      set((state): any => ({
          pagination: {
            page: projectUsersPageData.page,
            size: projectUsersPageData.size,
            total: projectUsersPageData.total
          },
          users: [
            ...state.users,
            ...(Array.isArray(projectUsersPageData.results) ? projectUsersPageData.results : [])
          ]
        })
      )
    },
  };
});

export const useUsersPage = () => {
  const { keycloak: { token }} = useKeycloak();

  return {
    loadUsersPage: async (_page: number) => {
      if (!token) return;

      const cacheKey = 'all_users';
      const now = Date.now();
      const cached = usersCache.get(cacheKey);

      // Return cached data if not expired
      if (cached && (now - cached.timestamp) < USERS_CACHE_TTL) {
        const setUsersPage = useUsersStore.getState().setUsersPage;
        setUsersPage(cached.data);
        return cached.data;
      }

      try {
      const setUsersPage = useUsersStore.getState().setUsersPage;
      const usersPage = await getUsers(token);
      usersCache.set(cacheKey, { data: usersPage, timestamp: now });
      setUsersPage(usersPage);
      return usersPage;
      } catch (error) {
        console.error('Error loading users page:', error);
        // Return empty response to prevent crashes
        return { results: [], page: 0, size: 0, total: 0 };
      }
    },
    addUserToProject: async (project_id: string, user_data:ProjectUserInterface) => {
      if (!token) return;
console.log(user_data)
      await addUserToProject(token, project_id, user_data.id, user_data);
    }
  }
}
